export enum SortTypes {
  asc = 'asc',
  desc = 'desc',
}

export interface ValidationMessage {
  type: string
  message: string
}

export enum UserRoles {
  Admin = 'adminUserGroup',
  Consultant = 'consultantUserGroup',
  Stakeholder = 'stakeholderUserGroup',
  Company = 'companyUserGroup',
  Vendor = 'vendorUserGroup',
}
